import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.142",
  height: "10.607",
  viewBox: "0 0 14.142 10.607"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { transform: "translate(456.084 -755.19) rotate(45)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0,0H5",
    transform: "translate(216.5 858.5)",
    fill: "none",
    stroke: "#E42313",
    "stroke-linecap": "round",
    "stroke-width": "3"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    y2: "9",
    transform: "translate(221.5 849.5)",
    fill: "none",
    stroke: "#E42313",
    "stroke-linecap": "round",
    "stroke-width": "3"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}